import { styled } from '@styledComponents';
import { Box } from '@components/Box';
import { TextPairing } from '@components/TextPairing';
import { Columns, Column } from '@components/Columns';
import { CloudImage } from '@components/CloudImage';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';

export const StyledContainer = styled(Box)`
  background: linear-gradient(180deg, #fcfaf8 0%, rgba(252, 250, 248, 1) 100%);
`;

export const WrapperBox = styled(Box)`
  overflow: visible;
  background: linear-gradient(180deg, #fcfaf8 0%, rgba(252, 250, 248, 1) 100%);
  background-repeat: no-repeat;
  background-blend-mode: multiply;
  background-position: bottom;
  background-size: contain;
  width: 100%;
  height: auto;
  justify-content: center;
  position: relative;
  max-width: 1920px;
  margin: auto;
  ${themeMediaQuery('below_sm')} {
    overflow: hidden;
  }
  ${themeMediaQuery('sm')} {
    overflow: visible;
  }
`;

export const StyledCloudImage = styled(CloudImage)`
  position: absolute;
  bottom: 0;
  ${themeMediaQuery('below_sm')} {
    z-index: 2;
  }
`;

export const Heading = styled(Box)`
  max-width: 505px;
  margin: auto;
  z-index: 3;
  position: relative;
  ${themeMediaQuery('xl')} {
    max-width: 640px;
  }
`;

export const StyledTextPairing = styled(TextPairing)`
  margin-bottom: ${themeSpace(5)};
  .text-pairing-title {
    margin-bottom: ${themeSpace(6)};
  }
`;

export const StyledColumns = styled(Columns)`
  z-index: 2;
  position: relative;
  @media screen and (min-width: 36rem) {
    max-width: 100%;
  }
  ${themeMediaQuery('sm')} {
    max-width: 67.5rem;
  }
  ${themeMediaQuery('lg')} {
    max-width: 79.5rem;
  }
`;

export const StyledColumn = styled(Column)`
  ${themeMediaQuery('sm')} {
    width: 33.33%;
    padding: 0 ${themeSpace(4)};
  }
  ${themeMediaQuery('md')} {
    padding: 0 ${themeSpace(6)};
  }
`;

export const StyledBox = styled(Box)`
  background: white;
  text-align: center;
  height: 423px;
  border-radius: 8px;
`;

export const MobileStyledBox = styled(Box)`
  ${themeMediaQuery('below_sm')} {
    display: initial;
    text-align: center;
    position: relative;
    z-index: 3;
    .slider,
    .slider-frame,
    .slider-list,
    .slider-slide {
      z-index: 3;
    }
  }
`;

export const CarouselItem = styled(Box)`
  background: white;
  width: 90%;
  margin-left: 10%;
  border-radius: 8px;
`;

export const ValueTextPairing = styled(TextPairing)`
  min-height: 100%;
  justify-content: center;
  align-items: center;
  div {
    margin-bottom: ${themeSpace(6)};
  }
  ${themeMediaQuery('below_sm')} {
    height: 341px;
    justify-content: center;
  }
`;

export const ForegroundBox = styled(Box)`
  position: absolute;
  bottom: 300px;
  width: 100%;
`;

export const MobileForegroundBox = styled(Box)`
  position: absolute;
  bottom: 0px;
  width: 100%;
  z-index: 2;
`;

export const ForegroundGridBox = styled(Box)`
  position: absolute;
  top: 0;
`;

export const MobileForegroundGridBox = styled(Box)<{ loaded: boolean }>`
  position: absolute;
  top: 0;
  left: ${({ loaded }) => (loaded ? '-35%' : '0px')};
  transform: translate(-55%, 0);
  z-index: 1;
`;
